import React, { FC } from 'react';
import { AdminSignupsView } from '../../components';

export const AdminSignupsPage: FC = () => <AdminSignupsView />;
